import { Button, Flex, Modal, Text, useTranslation } from "@familyzone/component-library";
import React, { useState } from "react";

interface PurgeSchoolsProps {
  onPurgeSchools: () => void;
  isSchoolsAvailable: boolean;
}

const PurgeSchools: React.FC<PurgeSchoolsProps> = ({ onPurgeSchools, isSchoolsAvailable }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);

  const onClose = () => {
    setIsOpen(false);
  };

  const onConfirmationClose = () => {
    setIsConfirmationOpen(false);
    onClose();
  };

  const onPurge = () => {
    setIsOpen(false);
    setIsConfirmationOpen(true);
  };

  const onConfirmation = () => {
    onPurgeSchools();
    onConfirmationClose();
  };

  return (
    <>
      <Button
        variant="danger"
        onClick={() => {
          setIsOpen(true);
        }}
        data-testid="open-purge-schools"
        disabled={!isSchoolsAvailable}
      >
        {t("Purge Schools")}
      </Button>
      <Modal headerText={t("Purge Schools")} variant="danger" size="md" isOpen={isOpen} onClose={onClose}>
        <Text mb="sp24" style={{ fontWeight: "bold" }}>
          {t("WARNING: Purge may stop Linewize Filter, Classroom Manager and Community features from working as expected.")}
        </Text>
        <Text mb="sp24">
          {t(
            "Purge deletes Schools and any User-School Associations. This can negatively impact Classroom Manager and Edtech Insights functionality. This should only be done when removing or changing a SIS Integration."
          )}
        </Text>
        <Flex>
          <Button
            mr="sp8"
            variant="danger"
            onClick={() => {
              onPurge();
            }}
            data-testid="purge-all-schools"
          >
            {t("Purge All Schools")}
          </Button>
          <Button variant="ghost" onClick={onClose} mr="sp8">
            {t("Cancel")}
          </Button>
        </Flex>
      </Modal>
      <Modal headerText={t("Are you sure?")} variant="danger" size="md" isOpen={isConfirmationOpen} onClose={onConfirmationClose}>
        <br></br>
        <Text mb="sp24" style={{ fontWeight: "bold" }}>
          {t("WARNING: YOU CANNOT UNDO THIS ACTION. Do you want to purge all schools from Linewize Filter?")}
        </Text>
        <Flex>
          <Button
            mr="sp8"
            variant="danger"
            onClick={() => {
              onConfirmation();
            }}
            data-testid="confirm-purge-schools"
          >
            {t("Confirm")}
          </Button>
          <Button variant="ghost" onClick={onConfirmationClose} mr="sp8">
            {t("Cancel")}
          </Button>
        </Flex>
      </Modal>
    </>
  );
};

export default PurgeSchools;
